export default function FinalCTA() {
  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative py-40 bg-black overflow-hidden">
      {/* Massive Central Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1400px] h-[1400px] bg-gradient-to-r from-cyan-500/30 via-blue-600/30 to-purple-600/30 rounded-full blur-3xl animate-pulse" />

      {/* Dense Particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(60)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-cyan-400 rounded-full animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${3 + Math.random() * 7}s`,
              opacity: Math.random() * 0.6 + 0.4,
              filter: 'blur(1px)'
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center scroll-reveal">
          {/* Main Headline */}
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            <span className="text-white drop-shadow-[0_0_40px_rgba(0,212,255,0.6)]">
              Your Business Should Be
            </span>
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 drop-shadow-[0_0_60px_rgba(0,212,255,0.8)]">
              Working Smarter
            </span>
          </h2>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-gray-400 mb-12 max-w-2xl mx-auto">
            Let AI handle the follow-up. You focus on the work.
          </p>

          {/* CTA Button */}
          <div className="mb-8">
            <button onClick={scrollToBooking} className="group relative px-12 py-6 bg-gradient-to-r from-cyan-400 via-blue-600 to-purple-600 text-white text-xl font-bold rounded-full overflow-hidden transition-all duration-500 hover:scale-110 hover:shadow-[0_0_80px_rgba(0,212,255,0.8)] whitespace-nowrap cursor-pointer">
              <span className="relative z-10 flex items-center justify-center gap-3">
                Book Your Demo Today
                <i className="ri-arrow-right-line text-2xl transition-transform group-hover:translate-x-2" />
              </span>
              
              {/* Animated Pulse Ring */}
              <div className="absolute inset-0 rounded-full border-4 border-cyan-400 animate-ping opacity-75" />
              <div className="absolute inset-0 rounded-full border-4 border-blue-600 animate-ping opacity-50" style={{ animationDelay: '0.5s' }} />
              
              {/* Hover Gradient */}
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-green-400 text-lg" />
              <span>No credit card required</span>
            </div>
            <div className="w-1 h-1 bg-gray-600 rounded-full" />
            <div className="flex items-center gap-2">
              <i className="ri-customer-service-2-line text-cyan-400 text-lg" />
              <span>Free consultation</span>
            </div>
            <div className="w-1 h-1 bg-gray-600 rounded-full" />
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-blue-400 text-lg" />
              <span>Setup in days, not months</span>
            </div>
          </div>

          {/* Stats Bar */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/5 backdrop-blur-xl border border-cyan-400/20 rounded-2xl p-6">
              <div className="text-4xl font-bold text-cyan-400 mb-2">500+</div>
              <div className="text-gray-400">Businesses Automated</div>
            </div>
            <div className="bg-white/5 backdrop-blur-xl border border-cyan-400/20 rounded-2xl p-6">
              <div className="text-4xl font-bold text-cyan-400 mb-2">10K+</div>
              <div className="text-gray-400">Leads Captured</div>
            </div>
            <div className="bg-white/5 backdrop-blur-xl border border-cyan-400/20 rounded-2xl p-6">
              <div className="text-4xl font-bold text-cyan-400 mb-2">98%</div>
              <div className="text-gray-400">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}